import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import "./LeaveApproval.scss";

interface LeaveApprovalDetailMobileProps {}

const LeaveApprovalDetailMobile: React.FC<LeaveApprovalDetailMobileProps> = () => {
  const { id } = useParams();
  const routes = all_routes;
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [actionType, setActionType] = useState<'approve' | 'reject'>('approve');
  const [comments, setComments] = useState('');
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');

  // Sample leave data - matches the mobile UI design
  const leaveData = {
    id: 15136,
    title: "Approve Special CL Sterilization, RAGHUVEER PRASAD",
    dateRange: "24.07.2025 - 24.07.2025",
    status: "New",
    employee: {
      name: "RAGHUVEER PRASAD",
      designation: "Sys.Analyst",
      id: "15136",
      timeStamp: "09.06.2025 16:17:33"
    },
    approver: {
      name: "OSHO ADITYA SAXENA",
      designation: "MANAGER/IT",
      id: "20990",
      timeStamp: "13.06.2025 09:58:12"
    },
    leaveDetails: {
      type: "Special CL Sterilization",
      description: "Special CL Sterilization",
      reasonForLeave: "",
      addressDuringLeave: "",
      cityDistrict: "",
      addressLine3: "",
      sterilizationOfSelf: true,
      startDate: "",
      endDate: "",
      lastNote: "",
      newNote: ""
    },
    attachment: {
      name: "attachment.pdf",
      exists: true
    }
  };

  const handleAction = (action: 'approve' | 'reject') => {
    setActionType(action);
    setShowApprovalModal(true);
  };

  const handleSubmitAction = () => {
    const message = actionType === 'approve' 
      ? `Leave request approved successfully!`
      : `Leave request rejected.`;
    
    setToastMessage(message);
    setShowToast(true);
    setShowApprovalModal(false);
    setComments('');
    
    setTimeout(() => {
      setShowToast(false);
    }, 3000);
  };

  const closeModal = () => {
    setShowApprovalModal(false);
    setComments('');
  };

  return (
    <div className="page-wrapper mobile-leave-approval">
      <div className="content">
        {/* Mobile Header */}
        <div className="mobile-header bg-danger text-white p-3 mb-3">
          <div className="d-flex align-items-center">
            <Link to={routes.todoWorklist.tasks} className="text-white me-3">
              <i className="ti ti-arrow-left fs-5"></i>
            </Link>
            <h5 className="mb-0 text-white">To Do Work List</h5>
          </div>
        </div>

        {/* Title Card */}
        <div className="card mb-3">
          <div className="card-body">
            <h6 className="mb-2">{leaveData.title}</h6>
            <p className="text-muted small mb-0">{leaveData.dateRange}, {leaveData.status}</p>
          </div>
        </div>

        {/* Leave Overview Card */}
        <div className="card mb-3">
          <div className="card-header bg-light">
            <h6 className="mb-0">Leave Overview</h6>
          </div>
          <div className="card-body">
            {/* Employee Section */}
            <div className="mb-4">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h6 className="text-primary mb-0">EMPLOYEE</h6>
                <button className="btn btn-sm btn-outline-primary">
                  View Leave and Time Account
                </button>
              </div>
              <div className="bg-light p-3 rounded">
                <div className="row small">
                  <div className="col-12 mb-2">
                    <span className="text-muted d-block">Name:</span>
                    <span className="fw-medium">{leaveData.employee.name} ({leaveData.employee.designation})</span>
                  </div>
                  <div className="col-6 mb-2">
                    <span className="text-muted d-block">ID:</span>
                    <span className="fw-medium">{leaveData.employee.id ? parseInt(leaveData.employee.id, 10) : leaveData.employee.id}</span>
                  </div>
                  <div className="col-6 mb-2">
                    <span className="text-muted d-block">Time Stamp:</span>
                    <span className="fw-medium">{leaveData.employee.timeStamp}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Approver Section */}
            <div className="mb-0">
              <h6 className="text-success mb-2">APPROVER</h6>
              <div className="bg-light p-3 rounded">
                <div className="row small">
                  <div className="col-12 mb-2">
                    <span className="text-muted d-block">Name:</span>
                    <span className="fw-medium">{leaveData.approver.name} ({leaveData.approver.designation})</span>
                  </div>
                  <div className="col-6 mb-2">
                    <span className="text-muted d-block">ID:</span>
                    <span className="fw-medium">{leaveData.approver.id}</span>
                  </div>
                  <div className="col-6 mb-2">
                    <span className="text-muted d-block">Time Stamp:</span>
                    <span className="fw-medium">{leaveData.approver.timeStamp}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Leave Details Card */}
        <div className="card mb-4">
          <div className="card-header bg-light">
            <h6 className="mb-0">Leave Details</h6>
          </div>
          <div className="card-body">
            {/* Type of Leave */}
            <div className="mb-4">
              <h6 className="fw-bold mb-2">Type of Leave</h6>
              <div className="bg-light p-3 rounded">
                <div className="mb-2">
                  <span className="text-muted small d-block">Type of Leave:</span>
                  <span className="fw-medium">{leaveData.leaveDetails.type}</span>
                </div>
                <div>
                  <span className="text-muted small d-block">Description:</span>
                  <span className="fw-medium">{leaveData.leaveDetails.description}</span>
                </div>
              </div>
            </div>

            {/* Additional Data */}
            <div className="mb-4">
              <h6 className="fw-bold mb-2">Additional Data</h6>
              <div className="bg-light p-3 rounded">
                <div className="mb-2">
                  <span className="text-muted small d-block">Reason For Leave:</span>
                  <span className="fw-medium">{leaveData.leaveDetails.reasonForLeave || '-'}</span>
                </div>
                <div className="mb-2">
                  <span className="text-muted small d-block">Address During Leave:</span>
                  <span className="fw-medium">{leaveData.leaveDetails.addressDuringLeave || '-'}</span>
                </div>
                <div className="mb-2">
                  <span className="text-muted small d-block">City/District:</span>
                  <span className="fw-medium">{leaveData.leaveDetails.cityDistrict || '-'}</span>
                </div>
                <div className="mb-2">
                  <span className="text-muted small d-block">Address Line 3:</span>
                  <span className="fw-medium">{leaveData.leaveDetails.addressLine3 || '-'}</span>
                </div>
                <div className="d-flex align-items-center">
                  <span className="text-muted small me-2">Sterilization of self:</span>
                  <span className="fw-medium">
                    {leaveData.leaveDetails.sterilizationOfSelf ? (
                      <i className="ti ti-check text-success"></i>
                    ) : (
                      <i className="ti ti-x text-danger"></i>
                    )}
                  </span>
                </div>
              </div>
            </div>

            {/* General Data */}
            <div className="mb-4">
              <h6 className="fw-bold mb-2">General Data</h6>
              <div className="bg-light p-3 rounded">
                <div className="row">
                  <div className="col-6">
                    <div className="mb-2">
                      <span className="text-muted small d-block">Start Date:</span>
                      <span className="fw-medium">{leaveData.leaveDetails.startDate || '-'}</span>
                    </div>
                    <div className="mb-2">
                      <span className="text-muted small d-block">Last Note:</span>
                      <span className="fw-medium">{leaveData.leaveDetails.lastNote || '-'}</span>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="mb-2">
                      <span className="text-muted small d-block">End Date:</span>
                      <span className="fw-medium">{leaveData.leaveDetails.endDate || '-'}</span>
                    </div>
                    <div className="mb-2">
                      <span className="text-muted small d-block">New Note:</span>
                      <span className="fw-medium">{leaveData.leaveDetails.newNote || '-'}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Attachment */}
            <div className="mb-0">
              <h6 className="fw-bold mb-2">Attachment</h6>
              <div className="bg-light p-3 rounded">
                {leaveData.attachment.exists ? (
                  <div className="d-flex align-items-center">
                    <i className="ti ti-file-text text-danger me-2"></i>
                    <span className="fw-medium">Attachment Name:</span>
                    <Link to="#" className="text-primary text-decoration-none ms-1">
                      {leaveData.attachment.name}
                    </Link>
                  </div>
                ) : (
                  <span className="text-muted">No attachment available</span>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Fixed Bottom Action Buttons */}
        <div className="fixed-bottom bg-white border-top p-3">
          <div className="row g-2">
            <div className="col-6">
              <button 
                className="btn btn-success w-100"
                onClick={() => handleAction('approve')}
              >
                <i className="ti ti-check me-1"></i>
                Approve
              </button>
            </div>
            <div className="col-6">
              <button 
                className="btn btn-danger w-100"
                onClick={() => handleAction('reject')}
              >
                <i className="ti ti-x me-1"></i>
                Reject
              </button>
            </div>
          </div>
        </div>

        {/* Add bottom padding to prevent content being hidden behind fixed buttons */}
        <div style={{ height: '80px' }}></div>
        {showApprovalModal && (
          <div className="modal fade show d-block" tabIndex={-1} style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h6 className="modal-title fw-bold">
                    {actionType === 'approve' ? 'Approve Leave' : 'Reject Leave'}
                  </h6>
                  <button 
                    type="button" 
                    className="btn-close" 
                    onClick={closeModal}
                  ></button>
                </div>
                <div className="modal-body">
                  <p className="mb-3">
                    Are you sure you want to {actionType} this leave request?
                  </p>
                  <div className="bg-light p-3 rounded mb-3">
                    <p className="mb-1 small"><strong>Employee:</strong> {leaveData.employee.name}</p>
                    <p className="mb-0 small"><strong>Leave Type:</strong> {leaveData.leaveDetails.type}</p>
                  </div>
                  
                  <div className="mb-3">
                    <label className="form-label small fw-medium">
                      {actionType === 'approve' ? 'Comments (Optional)' : 'Rejection Reason'}
                    </label>
                    <textarea 
                      className="form-control form-control-sm" 
                      rows={3} 
                      value={comments}
                      onChange={(e) => setComments(e.target.value)}
                      placeholder={`Enter ${actionType} comments...`}
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <button 
                    type="button" 
                    className="btn btn-outline-secondary btn-sm" 
                    onClick={closeModal}
                  >
                    Cancel
                  </button>
                  <button 
                    type="button" 
                    className={`btn btn-sm ${actionType === 'approve' ? 'btn-success' : 'btn-danger'}`}
                    onClick={handleSubmitAction}
                  >
                    <i className={`ti ${actionType === 'approve' ? 'ti-check' : 'ti-x'} me-1`}></i>
                    {actionType === 'approve' ? 'Approve' : 'Reject'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Success Toast */}
        {showToast && (
          <div className="position-fixed top-0 start-50 translate-middle-x mt-3" style={{ zIndex: 1055 }}>
            <div className="toast show" role="alert">
              <div className={`toast-header ${actionType === 'approve' ? 'bg-success' : 'bg-danger'} text-white`}>
                <i className={`ti ${actionType === 'approve' ? 'ti-check-circle' : 'ti-x-circle'} me-2`}></i>
                <strong className="me-auto">Success</strong>
                <button 
                  type="button" 
                  className="btn-close btn-close-white" 
                  onClick={() => setShowToast(false)}
                ></button>
              </div>
              <div className="toast-body">
                {toastMessage}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LeaveApprovalDetailMobile;
